import React from 'react';
import { DangerousHTML } from './DangerousHTML';
import { Line } from './Line';

interface DataProps {
  color: string,
  secondaryColor: string,
  datas: Array<{ data: string, text: string }>,
}

export const Data: React.FC<DataProps> = ({
  color, secondaryColor, datas,
}: DataProps) => (
  <div className="data">
    {datas.map(
      ({ data, text }, index) => (
        <div key={index} className="data__wrapper">
          {index > 0 && <Line color={secondaryColor} />}
          <div className="data__part">
            <h3 className="data__number" style={{ color }}>{data}</h3>
            <div className="data__text" style={{ color }}>
              <DangerousHTML
                element="div"
                html={text}
              />
            </div>
          </div>
        </div>
      ),

    )}
  </div>
);
